import {
  type EditorValue,
  type MentionItem,
  parseDraftString,
  takeMentionIds,
} from '@octopus-do/octopus-editor'

import type { Recipient } from '@/types'

// todo: make backend comments migration
export const parseCommentDraft = (lsDraft: string | null): EditorValue => {
  if (!lsDraft) {
    return []
  }

  try {
    const parsed = JSON.parse(lsDraft)
    if (Array.isArray(parsed)) {
      return parsed
    }
    return parseDraftString(lsDraft)
  } catch {
    return []
  }
}

// todo: move to backend on comment save
export const parseRecipients = (comment: string): string[] => {
  if (!comment) {
    return []
  }

  return takeMentionIds(parseCommentDraft(comment))
}

export const buildMention = ({ id, fullName }: Recipient): MentionItem => ({
  id,
  title: fullName,
})
